import { SITE } from "@/config/site";

// Envia um formulário para o Worker do site (/api/enviar), que o encaminha por email.
// Só termina sem erro quando o servidor confirma o envio, por isso o site nunca mostra "sucesso" sem a mensagem ter seguido.
export async function sendForm({ form, lang, fields, honeypot = "", startedAt }) {
  let res;
  try {
    res = await fetch(SITE.formEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ form, lang, fields, website: honeypot, t: startedAt, consent: true }),
    });
  } catch {
    throw new Error("network");
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.ok !== true) throw new Error(data.code || "send_failed");
}
